import React from 'react'

import Divider from 'components/common/Divider'
import theme from 'theme'

const DividerWithText: React.FC = ({ children = 'or', ...rest }) => (
  <div
    data-test-divider-with-text
    css={{
      marginTop: theme.space[3],
      marginBottom: theme.space[3],
      display: 'flex',
      alignItems: 'center'
    }}
    {...rest}
  >
    <Divider />
    <p
      css={{
        fontSize: theme.fontSizes[2],
        margin: `0 ${theme.space[4]}px`,
        lineHeight: `${theme.fontSizes[1]}px`,
        color: theme.colors.steel[2],
        fontWeight: theme.fontWeights[0]
      }}
    >
      {children}
    </p>
    <Divider />
  </div>
)

export default DividerWithText
